export default function SectionHeader({ title, subtitle, action, border = false, className = "", actionClassName = "" }) {
  return (
    <div className={`flex items-start justify-between ${border ? "pb-4 mb-4 border-b border-border" : "mb-4"} ${className}`}>
      <div className="min-w-0">
        <h3 className="text-sm font-bold text-ink dark:text-slate-100">{title}</h3>
        {subtitle && <p className="text-xs text-muted dark:text-slate-300 mt-0.5">{subtitle}</p>}
      </div>
      {action && <div className={`flex-shrink-0 ${actionClassName}`}>{action}</div>}
    </div>
  );
}
